import { LOCALES } from '../../locales';

export default {
  [LOCALES.DE]: {
    app_gallety_all_apps: '{uploaded_apps} All Apps {total_apps}',
    //application filters
    app_gallery_categories: 'Categories',
    app_gallery_types: 'Types',
    app_gallery_products: 'Products',
  },
};
